<form [formGroup]="emailForm" (ngSubmit)="requestEmailChange()" novalidate>
  <div class="row mt-2">
    <div class="col-12">
      <input type="text" [class]="mode == FORM_COMP_MODES.DISPLAY ? 'form-control-plaintext' : 'form-control'"
        name="email" id="email" formControlName="email" maxlength="100" autocomplete="off"
        [readonly]="mode == FORM_COMP_MODES.DISPLAY"
        placeholder="{{ 'Template.SettingsComponent.label_emailAdress' | translate }}">
    </div>
  </div>

  @if (emailError) {
    <div class="alert alert-danger text-center mt-2">
      {{emailError}}
    </div>
  }

  @if (mode == FORM_COMP_MODES.CREATE || mode == FORM_COMP_MODES.EDIT) {
    <div class="mt-2 d-flex justify-content-center">
      <button type="submit" class="btn btn-success d-block w-100" [disabled]="!emailForm.valid">
        {{ 'Template.EmailFormLegacyComponent.btn_save' | translate }}
        <fa-icon icon="chevron-right"></fa-icon>
        @if (emailLoading) {
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        }
      </button>
    </div>
  }
</form>
